module.exports = __webpack_public_path__ + "img/icon_j4.f1629fa.png";